











































import { Component, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { Storage } from "aws-amplify";

@Component
export default class ImagePicker extends Vue {

    @Model('modified', {type: String})
    path!: string;

    @Prop({default: false, type: Boolean})
    contain!: boolean;

    @Prop()
    id!: string;

    @Prop({default: ''})
    icon!: string;

    @Prop()
    label!: string;

    @Prop()
    description!: string;

    @Prop()
    keyPrefix!: string;

    @Prop({default: '64px'})
    imageWidth!: string;

    @Prop({default: '64px'})
    imageHeight!: string;

    @Prop({default: 'auto'})
    imageMinWidth!: string;

    @Prop({default: 'auto'})
    imageMinHeight!: string;

    private file: File | null = null;
    private newPath: string = '';
    private filePath = '';
    private refreshCounter = 0;
    private loadingImage = false;

    private imagePath: any = null;

    rules = [
        (value: any) => !value || value.size <= 1000000 || 'Unable to upload file of that size. Max size is 1 MB',
    ];

    $refs!: {
        imagePicker: HTMLFormElement,
        fileInput: HTMLFormElement
    };

    @Watch('path')
    onPathChange(newVal: string, oldVal: string) {
        this.filePath = newVal;
        this.getImage();
        this.refreshCounter++;
    }

    get styles() {
        return {
            "height":     'auto',
            "min-height": this.imageHeight,
            "max-height": this.imageHeight,
            "width":     'auto',
            "min-width": this.imageWidth,
            "max-width": this.imageWidth,
        };
    }

    mounted() {
        this.filePath = this.path;
        this.getImage()
    }

    getImage() {
        Storage.get(this.filePath)
            .then(res => this.imagePath = res.toString())
    }

    clickk() {
        this.$refs.fileInput.$refs.input.click();
    }

    fileChange(file: any) {
        if (file) {
            if (!this.$refs.imagePicker.validate()) {
                return
            }
            this.filePath = '';
            let fileName = file.name;
            let lastIndexOfPeriod = fileName.lastIndexOf(".");
            if (lastIndexOfPeriod > 0) {
                let fileNameWithoutExtension = fileName.substring(0, lastIndexOfPeriod);
                let extension = fileName.substring(lastIndexOfPeriod);
                fileName = fileNameWithoutExtension + '-' + new Date().getTime() + extension
            } else {
                fileName = fileName + '-' + new Date().getTime()
            }
            let key = `${this.keyPrefix}/${fileName}`;

            this.loadingImage = true;
            Storage.put(key, file)
                .then((result: any) => {
                    this.newPath = result.key;
                    this.filePath = result.key
                    this.$emit("modified", result.key)
                    this.loadingImage = false;
                });
        } else {
            this.newPath = '';
            this.filePath = this.path;
        }
    }

}
